import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, DestroyRef, HostBinding, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { RouterLink } from '@angular/router';
import { map } from 'rxjs/operators';

import { HeaderElementDirective } from '@core/shared/util';
import {
  ConfirmDialogData,
  ConfirmDialogService,
  InfiniteScrollComponent,
  OverviewModule,
  RootModuleNavComponent,
} from '@core/ui';
import { CategoriesService } from '@mpcm/shared';

import { ArticleRangeInfo } from '../../models';
import {
  ArticleRangeService,
  CategoryCacheService,
  CategoryTypesService,
  FilterTypesService,
  OrganizationsCacheService,
  SupplierCacheService,
} from '../../services';
import { ArticleRangesFacade } from '../../store';

@Component({
  selector: 'mpcm-article-ranges-overview',
  templateUrl: './article-ranges-overview.component.html',
  styleUrl: './article-ranges-overview.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    AsyncPipe,
    RouterLink,

    MatIconModule,
    MatMenuModule,

    OverviewModule,
    InfiniteScrollComponent,
    RootModuleNavComponent,
    HeaderElementDirective,
  ],
  providers: [
    CategoriesService,

    ArticleRangesFacade,
    ArticleRangeService,

    SupplierCacheService,
    CategoryCacheService,
    OrganizationsCacheService,
    CategoryTypesService,
    FilterTypesService,
  ],
})
export class ArticleRangesOverviewComponent implements OnInit {
  @HostBinding('class') protected readonly class = 'mpcm-article-ranges-overview';

  protected readonly dataSource = this.facade.dataSource;
  protected readonly resultCount$ = this.facade.pagination$.pipe(map((pagination) => pagination?.totalRowCount));

  constructor(
    private readonly facade: ArticleRangesFacade,
    private readonly confirmDialogService: ConfirmDialogService,
    private readonly destroyRef: DestroyRef,
  ) {}

  ngOnInit(): void {
    this.dataSource.updateQueryParams({});
  }

  protected handleSearch(searchTerm: string): void {
    this.dataSource.updateQueryParams({ searchTerm });
  }

  protected deleteArticleRange(articleRange: ArticleRangeInfo): void {
    const { articleRangeId, name, organizationCount } = articleRange;

    const dialogData: ConfirmDialogData = {
      title: 'Sortiment löschen',
      message:
        `Soll das Sortiment "${name}" wirklich gelöscht werden?` +
        (organizationCount > 0
          ? ` Das Sortiment ist noch ${organizationCount} Organisation${
              organizationCount === 1 ? '' : 'en'
            } zugeordnet.`
          : ''),
      trueButtonText: 'Löschen',
      falseButtonText: 'Abbrechen',
    };

    this.confirmDialogService
      .open(dialogData)
      .afterClosed()
      .pipe(takeUntilDestroyed(this.destroyRef))
      // eslint-disable-next-line rxjs-angular/prefer-async-pipe, rxjs/no-ignored-error
      .subscribe((confirmed) => {
        if (confirmed) {
          this.facade.deleteArticleRange(articleRangeId);
        }
      });
  }
}
